import React from 'react';

import { Section, Settings } from '@/models';
import { Contact } from '../contact';

interface ContactListProps {
  section: Section;
  settings: Settings;
}

const ContactList = ({ section }: ContactListProps) => {
  const whatsappBlock = section.blocks.find(
    (block) => block.settings.type === 'whatsapp',
  );
  const phoneBlock = section.blocks.find(
    (block) => block.settings.type === 'phone',
  );
  const emailBlock = section.blocks.find(
    (block) => block.settings.type === 'email',
  );
  const smsBlock = section.blocks.find(
    (block) => block.settings.type === 'sms',
  );
  const facebookBlock = section.blocks.find(
    (block) => block.settings.type === 'facebook',
  );
  const wechatBlock = section.blocks.find(
    (block) => block.settings.type === 'wechat',
  );
  const lineBlock = section.blocks.find(
    (block) => block.settings.type === 'line',
  );
  const viberBlock = section.blocks.find(
    (block) => block.settings.type === 'viber',
  );

  return (
    <Contact
      title={section.plain_text}
      sms={{ value: smsBlock?.settings?.url, label: smsBlock?.plain_text }}
      phone={{
        value: phoneBlock?.settings?.url,
        label: phoneBlock?.plain_text,
      }}
      email={{
        value: emailBlock?.settings?.url,
        label: emailBlock?.plain_text,
      }}
      whatsapp={{
        value: whatsappBlock?.settings?.url,
        label: whatsappBlock?.plain_text,
      }}
      facebook={{
        value: facebookBlock?.settings?.url,
        label: facebookBlock?.plain_text,
      }}
      wechat={{
        value: wechatBlock?.settings?.url,
        label: wechatBlock?.plain_text,
      }}
      line={{
        value: lineBlock?.settings?.url,
        label: lineBlock?.plain_text,
      }}
      viber={{
        value: viberBlock?.settings?.url,
        label: viberBlock?.plain_text,
      }}
    />
  );
};

export default ContactList;
